// src/components/Blog/BlogPost.js
import React from 'react';

const BlogPost = ({ post, darkMode, onBack, onEdit, onDelete, isAdmin }) => {
    return (
        <div className={`${darkMode ? 'text-white' : ''}`}>
            <div className="flex justify-between items-center mb-4">
                <button
                    onClick={onBack}
                    className={`flex items-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}
                >
                    <i className="fas fa-arrow-left mr-2"></i> Назад
                </button>

                {isAdmin && (
                    <div className="flex space-x-2">
                        <button
                            onClick={() => onEdit(post)}
                            className="text-blue-500"
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                        <button
                            onClick={() => onDelete(post.id)}
                            className="text-red-500"
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    </div>
                )}
            </div>

            <h2 className="text-2xl font-bold mb-4">{post.title}</h2>

            {post.mainImage && (
                <img
                    src={post.mainImage}
                    alt={post.title}
                    className="w-full h-64 object-cover rounded-lg mb-4"
                />
            )}

            {post.tags && post.tags.length > 0 && (
                <div className="flex flex-wrap mb-4">
                    {post.tags.map((tag, index) => (
                        <span
                            key={index}
                            className={`text-xs px-2 py-1 rounded-full mr-2 mb-1 ${darkMode ? 'bg-gray-700' : 'bg-gray-200'
                                }`}
                        >
                            {tag}
                        </span>
                    ))}
                </div>
            )}

            <div className={`mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                {post.date}
            </div>

            <div
                className={`blog-content ${darkMode ? 'text-gray-300' : 'text-gray-800'}`}
                dangerouslySetInnerHTML={{ __html: post.content }}
            />
        </div>
    );
};

export default BlogPost;